import uiRouter from 'angular-ui-router';
import 'angular-sanitize';
import 'ng-csv';

import myVacations from './myVacations.component';
import VacationScheduleEndDateService from './vacationScheduleEndDate.service';
import periodList from './periodList/periodList';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let myVacationsModule = angular.module('vacations-absences.myVacations', [
  uiRouter,
  periodList,
  'ngSanitize',
  'ngCsv'
])

.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state(STATES.VACATIONS_ABSENCES.MY_VACATIONS, {
      url: ROUTES.VACATIONS_ABSENCES.MY_VACATIONS,
      component: 'myVacations',
      data:{
        requiresAuth:true
      },
      resolve: {
        /* @ngInject */
        isWageInProcess: (StatusAppCheckers) => StatusAppCheckers.isWageInProcess()
      }
    });
})

.component('myVacations', myVacations)

.service('VacationScheduleEndDateService', VacationScheduleEndDateService)

.name;

export default myVacationsModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/myVacations.js